import { useMemo } from 'react';
import { Trans } from 'react-i18next';

import { DisplayableLink } from './DisplayableLink';

export type DisplayableMessage = {
   linkInterpolations?: Record<string, DisplayableLink>;
   message: string;
};

type DisplayableMessageProps = DisplayableMessage;

export const DisplayableMessage = (props: DisplayableMessageProps): JSX.Element => {
   const components = useMemo(() => {
      return Object.entries(props.linkInterpolations ?? {}).reduce((components, [key, value]) => {
         components[key] = <DisplayableLink testId={key} label={value.label} href={value.href} />;
         return components;
      }, {} as Record<string, JSX.Element>);
   }, [props.linkInterpolations]);

   const i18nKeyWithComponentsInterpolation = props.message.replace('{{', '<').replace('}}', ' >');

   return (
      <span>
         <Trans i18nKey={i18nKeyWithComponentsInterpolation} components={components} />
      </span>
   );
};
